import { AfterViewInit, Directive, ElementRef, HostBinding, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { ContentElement, ContentElementEnum } from '../../models/sections-model';

@Directive({
  selector: '[kwElementStyler]'
})
export class ElementStylerDirective implements OnChanges,AfterViewInit{
  @Input() contentElement:ContentElement;
  @Input() preview:boolean;
  containerEl:HTMLElement;
  @HostBinding("style.--header-background") hdrbackground:string;
  @HostBinding("style.--header-padding") hdrpadding:string;
  @HostBinding("style.--content-element-text-color") color:string;
  @HostBinding("style.--content-element-font-family") fontFamily:string;
  @HostBinding("style.--content-element-background") background:string;
  @HostBinding("style.--content-element-font-weight") fontWeight:string;
  @HostBinding("style.--content-border-color") borderColor:string = "transparent";
  @HostBinding("style.--content-border-width") borderWidth:string = "0px";
  @HostBinding("style.--content-border-style") borderStyle:string;
  @HostBinding("style.--content-container-padding") containerPadding:string;
  //@HostBinding("style.--content-element-padding") padding:string;
  @HostBinding("style.--content-element-underlineThick") underlineThickness:string = "0px";
  @HostBinding("style.--content-element-underlineSpace") underlineSpacing:string = "auto";
  @HostBinding("style.--content-element-underline") underline:string = "none";
  //@HostBinding("style.--content-element-border") border:string;
  @HostBinding("style.border") border:string;
  @HostBinding("style.border-radius") borderRadius:string;
  @HostBinding("style.padding") padding:string

  //'border-color':''+contentElement?.borderColor+'','padding':''+contentElement?.padding+'','font-weight':''+contentElement?.fontWeight+'','padding-top':''+contentElement?.paddingTop+'','padding-bottom':''+contentElement?.paddingBottom+'','padding-right':''+contentElement?.paddingRight+'','padding-left':''+contentElement?.paddingLeft+'','border-width':''+contentElement?.borderWidth+''
  
  constructor(private el:ElementRef<HTMLElement>,private renderer:Renderer2) { }
  
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["contentElement"]){
      /* if(this.contentElement?.borderColor != undefined && this.contentElement.borderColor != "") {
        this.borderColor = this.contentElement.borderColor;
      } */
      
      this.setBorderProperty(this.contentElement);
      this.setBorderRadiusProperty(this.contentElement);
      this.setPaddingPropery(this.contentElement);
      
      if(this.contentElement?.containerPadding != undefined) this.containerPadding = this.contentElement.containerPadding;

      if(this.contentElement?.color != undefined) this.color = this.contentElement.color
      if(this.contentElement?.fontFamily != undefined) this.fontFamily = this.contentElement.fontFamily
      if(this.contentElement?.background != undefined) this.background = this.contentElement.background
      if(this.contentElement?.fontWeight != undefined) this.fontWeight = this.contentElement.fontWeight;
      if(this.contentElement?.padding != undefined) this.padding = this.contentElement.padding;
      if(this.contentElement?.underLineThickness != undefined) {
        this.underlineThickness = this.contentElement.underLineThickness;
        this.underline = "underline";
      }
      if(this.contentElement?.underLineDistance != undefined) this.underlineSpacing = this.contentElement.underLineDistance;

      //console.log({containerPadding:this.containerPadding})
    }
    /* if(changes["preview"]){
      console.log(this.preview)
    } */
    /* if(changes["contentElement"]){
      if(this.contentElement != undefined){
        if(this.contentElement["contentElementEnum"] != undefined){
          switch (this.contentElement.contentElementEnum) {
            case "header":
              let regex = /h\d/i;
              if(!this.contentElement.classes.some(e => regex.test(e))){
                this.contentElement.classes.push("h6")
              }
              if(!this.contentElement.classes.includes("content-header")){
                this.contentElement.classes.push("content-header")
              }
              if(this.contentElement.background != undefined){
                this.background = this.contentElement.background;
              }
              if(this.contentElement.padding != undefined){
                this.padding = this.contentElement.padding;
              }
              if(this.contentElement.classes.includes("kve-fullWidth")){
                this.containerEl.classList.add("full-width");
              }
             
              break;
          
            default:
              break;
          }
          
        }
      }
      
      console.log(this.contentElement)
    } */
  }


  ngAfterViewInit(): void {
    if(this.contentElement != undefined){
      this.containerEl = this.el.nativeElement.closest(".content-element-container")
      if(this.contentElement["contentElementEnum"] != undefined){
        let enumValue = this.getEnumValue(this.contentElement);
        switch (enumValue) {
          case "header":
            let regex = /h\d/i;
            if(!this.contentElement.classes.some(e => regex.test(e))){
              this.contentElement.classes.push("h3")
            }
            if(!this.contentElement.classes.includes("content-header")){
              this.contentElement.classes.push("content-header")
            }
            if(this.contentElement.background != undefined){
              this.background = this.contentElement.background;
            }
            if(this.contentElement.padding != undefined){
              this.padding = this.contentElement.padding;
            }
            if(this.contentElement.classes.includes("kve-fullWidth")){
              this.containerEl.classList.add("full-width");
            }
           
            break;
        
          default:
            break;
        }
        
      }
      this.addContentElementClasses(this.contentElement)
      if(this.contentElement.paddingTop  != undefined){
        this.renderer.setStyle(this.el,"padding-top",this.contentElement.paddingTop)
      }
      if(this.preview == true){
        this.renderer.setAttribute(this.el.nativeElement,"contenteditable","true")
      }
      //Set container classes
        
      
    }
    
    //this.containerEl = this.el.nativeElement.closest(".content-element-container")
    /* if(this.contentElement != undefined && this.contentElement.paddingTop  != undefined){
      this.renderer.setStyle(this.el,"padding-top",this.contentElement.paddingTop)
    } */
    //Add Padding Class to classes
    
    
  }
  //Add class poroperties to contentClasses array;
  addContentElementClasses(contentElement:ContentElement){
    if(contentElement?.paddingClass != undefined && !contentElement.classes.includes(contentElement.paddingClass)){
      contentElement.classes.push(contentElement.paddingClass);
    }
  }

  getEnumValue(contentElement:ContentElement){
    let enumValue:string;
    let cntEnum = contentElement.contentElementEnum
    if(cntEnum != undefined){
      if((cntEnum).includes(".")){
        let enumKey = cntEnum.split('.')[1] as keyof typeof ContentElementEnum;
        enumValue = ContentElementEnum[enumKey];
      }else if(ContentElementEnum[cntEnum] != undefined){
        enumValue = ContentElementEnum[cntEnum]
      }else{
        enumValue = cntEnum;
      }
    }
    //if(enumValue) enumValue = <string>enumValue.toUpperCase();
    console.log(enumValue)    
    return enumValue;
  }
  /**
   * 
   * @param contentElement 
   *
   * Check if there is a border property on the contentElement.
   * If there is a border property, set the border hostBinding for border
   * If the is no border property, but there is inidividual borderWidth, borderColor and borderStyle properties - use it to set the border property
   *
   */
  setBorderProperty(contentElement:ContentElement):void{
    if(!contentElement){
      return
    }
    if(contentElement.border) {
      this.border = contentElement.border
    } else {
      const width = this.contentElement.borderWidth?this.contentElement.borderWidth:"0px";
      const style = this.contentElement.borderStyle?this.contentElement.borderStyle:"solid";
      const color = this.contentElement.borderColor?this.contentElement.borderColor:"transparent";
      this.border = `${width} ${style} ${color}`
    }
  }

  setBorderRadiusProperty(contentElement:ContentElement):void{
    if(!contentElement){
      return
    }
    if(this.contentElement?.borderRadius != undefined && this.contentElement?.borderRadius != "") {
      this.borderRadius = this.contentElement.borderRadius;
    }else{
      const topleft = this.contentElement.borderRadiusTopLeft?this.contentElement.borderRadiusTopLeft:"0px";
      const topRight = this.contentElement.borderRadiusTopRight?this.contentElement.borderRadiusTopRight:"0px";
      const bottomRight = this.contentElement.borderRadiusBottomRight?this.contentElement.borderRadiusBottomRight:"0px";
      const bottomleft = this.contentElement.borderRadiusBottomLeft?this.contentElement.borderRadiusBottomLeft:"0px";
      this.borderRadius = `${topleft} ${topRight} ${bottomRight} ${bottomleft}`
    }
  }

  setPaddingPropery(contentElement:ContentElement){
    if(!contentElement){
      return
    }
    if(!contentElement){
      return
    }
    if(this.contentElement?.padding != undefined && this.contentElement?.padding != "") {
      this.padding = this.contentElement.padding;
    }else{
      const paddingTop = this.contentElement.borderRadiusTopLeft?this.contentElement.borderRadiusTopLeft:"0px";
      const paddingRight = this.contentElement.borderRadiusTopRight?this.contentElement.borderRadiusTopRight:"0px";
      const paddingBottom = this.contentElement.borderRadiusBottomRight?this.contentElement.borderRadiusBottomRight:"0px";
      const paddingleft = this.contentElement.borderRadiusBottomLeft?this.contentElement.borderRadiusBottomLeft:"0px";
      this.padding = `${paddingTop} ${paddingRight} ${paddingBottom} ${paddingleft}`
    }
  }


}
